import { ColumnDef } from '@tanstack/react-table';

import Table from '../common/Table';

import { IUser } from '@/interfaces/api/IUser';

interface Props {
	users: IUser[];
	columns: ColumnDef<IUser>[];
}

const StoreMerchantsTable = ({ users, columns }: Props) => {
	return (
		<div
			className="flex flex-col items-center border-t border-gray-300 w-full bg-grey-0 border border-gray-300 rounded-md px-[2rem]"
			data-test="store-merchants-table"
		>
			<div className="w-full">
				<h3 className="text-md leading-5 font-medium my-[2rem]">Users List</h3>
				<div className="flex items-center justify-between w-full mb-1">
					<div
						data-test="total-merchants-count"
						className="inter-small-semibold p-3 pl-0 text-grey-50"
					>{`Total Users : ${users.length}`}</div>
				</div>
			</div>
			<Table<IUser>
				collection={{
					data: users,
					itemCount: users.length,
					pageCount: 1,
					pageSize: 10,
					pageNumber: 1,
				}}
				columns={columns}
				tableStyles={{ table: 'w-full' }}
				dataTest="store-merchants-table"
			/>
		</div>
	);
};
export default StoreMerchantsTable;
